import { FunctionFactory } from 'survey-core';
import { BodyType } from '../quiz/bodytype';
import { tSurvey } from '../i18n/survey';
import { makeSplashHeader } from './SplashHeader';

const bodyTypeSplashHtml =`
<div class="new-quote-container centered">
  <div class="splash-icon">{bodyTypeIcon}</div>
  <div class="splash-header">
    <h1>{bodyTypeTitle}</h1>
    <div class="quote">{bodyTypeContent}</div>
  </div>
</div>`;

const bodyTypeSplashContentMap = {
    [BodyType.Skinny]: {
      icon: "📍",
      title: "splash.bodyType.title.rightPlace",
      text: "splash.bodyType.text.skinny",
    },
    [BodyType.SkinnyFat]: {
      icon: "📍",
      title: "splash.bodyType.title.rightPlace",
      text: "splash.bodyType.text.skinny",
    },
    [BodyType.Defined]: {
      icon: "📍",
      title: "splash.bodyType.title.greatSpot",
      text: "splash.bodyType.text.defined",
    },
    [BodyType.Athletic]: {
      icon: "📍",
      title: "splash.bodyType.title.greatSpot",
      text: "splash.bodyType.text.defined",
    },
    [BodyType.Bulky]: {
      icon: "📍",
      title: "splash.bodyType.title.greatSpot",
      text: "splash.bodyType.text.bulky",
    },
    [BodyType.Overweight]: {
      icon: "🤝",
      title: "splash.bodyType.title.gotYou",
      text: "splash.bodyType.text.overweight",
    },
} as const;

function renderBodyTypeSplashIcon(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  return bodyTypeSplashContentMap[params[0] as BodyType].icon;
}
FunctionFactory.Instance.register("bodyTypeSplashIcon", renderBodyTypeSplashIcon);
const bodyTypeSplashIconExpression = {
  name: "bodyTypeIcon",
  expression: "bodyTypeSplashIcon({bodyType})",
};

function renderBodyTypeSplashTitle(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  const bodyType = params[0] as BodyType;
  return tSurvey(bodyTypeSplashContentMap[bodyType].title);
}
FunctionFactory.Instance.register("bodyTypeSplashTitle", renderBodyTypeSplashTitle);
const bodyTypeSplashTitleExpression = {
  name: "bodyTypeTitle",
  expression: "bodyTypeSplashTitle({bodyType})",
};

function renderBodyTypeSplashContent(params: any[]): string {
  if (params === undefined || params === null || !params[0]) return "";
  const bodyType = params[0] as BodyType;
  return tSurvey(bodyTypeSplashContentMap[bodyType].text);
}
FunctionFactory.Instance.register("bodyTypeSplashContent", renderBodyTypeSplashContent);
const bodyTypeSplashContentExpression = {
  name: "bodyTypeContent",
  expression: "bodyTypeSplashContent({bodyType})",
};

const bodyTypeSplashElement = {
  name: "body-type-splash",
  type: "html",
  html: bodyTypeSplashHtml,
}

const BodyTypeSplashHeader = makeSplashHeader("splash.headers.bodyType");

export {
  bodyTypeSplashElement,
  bodyTypeSplashIconExpression,
  bodyTypeSplashTitleExpression,
  bodyTypeSplashContentExpression,
  BodyTypeSplashHeader,
}
